module.exports = __webpack_public_path__ + "static/media/tier-8.9f6956d7.jpg";